<template>
  <v-container class="mt-4 ml-2 textoPoppins" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="pb-0">
            <div>
              <div class="text-subtitle-1 font-weight-bold">Pagos · Recursos Vendedor IA</div>
              <div class="text-caption grey--text">
                Gates de pago + PDFs y audios oficiales (métodos de pago, método/inmersión y audio de propuesta por curso y escuela)
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn small text :to="{ name: 'twilioSandbox' }">
              <v-icon left small>mdi-whatsapp</v-icon>
              Sandbox
            </v-btn>
            <v-btn small color="primary" class="ml-2" :loading="cargando" @click="cargarTodo">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-alert v-if="status" dense outlined type="info" class="mb-3">
              <span class="text-caption">
                Entorno: <strong>{{ status.entorno }}</strong> · BD:
                <strong>{{ status.db_twilio }}</strong> · Handoff comprobante:
                <strong>{{ status.handoff_comprobante ? 'ON' : 'OFF' }}</strong>
              </span>
            </v-alert>
            <v-alert v-if="error" dense type="error" class="mb-3" dismissible @input="error = null">
              {{ error }}
            </v-alert>
            <v-alert dense outlined type="warning" class="mb-3">
              <div class="text-caption">
                La IA <strong>no</strong> inventa CLABE ni cuentas: solo manda el recurso activo.
                Si el lead manda PDF/comprobante, la IA se suspende y pasa a humano (no registra el pago).
              </div>
            </v-alert>

            <v-tabs v-model="tab" background-color="transparent" grow>
              <v-tab>Gates (preguntas)</v-tab>
              <v-tab>Recursos PDF / audio</v-tab>
              <v-tab>Probar evaluación</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" class="mt-4">
              <!-- GATES -->
              <v-tab-item>
                <div class="text-caption grey--text mb-3">
                  Marca <strong>Requerido</strong> para exigirlo antes de
                  <code>obtener_metodos_pago</code>. Defaults: programa + “quiere inscribirse” = sí;
                  inversión / examen / grupo = no.
                </div>
                <v-data-table
                  :headers="headersGates"
                  :items="gates"
                  dense
                  :loading="cargando"
                  class="elevation-0"
                >
                  <template v-slot:item.requerido_sn="{ item }">
                    <v-switch
                      v-model="item.requerido_sn"
                      dense
                      hide-details
                      :true-value="1"
                      :false-value="0"
                      @change="guardarGate(item)"
                    ></v-switch>
                  </template>
                  <template v-slot:item.activo_sn="{ item }">
                    <v-switch
                      v-model="item.activo_sn"
                      dense
                      hide-details
                      :true-value="1"
                      :false-value="0"
                      @change="guardarGate(item)"
                    ></v-switch>
                  </template>
                  <template v-slot:item.orden="{ item }">
                    <v-text-field
                      v-model.number="item.orden"
                      type="number"
                      dense
                      hide-details
                      style="max-width: 72px"
                      @blur="guardarGate(item)"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-tab-item>

              <!-- RECURSOS -->
              <v-tab-item>
                <div class="d-flex align-center mb-3 flex-wrap">
                  <div class="text-caption grey--text mr-4" style="max-width: 420px">
                    Sube el PDF, imagen u <strong>audio</strong> oficial (ogg/mp3/m4a).
                    Clasifica por <strong>tipo</strong>, <strong>escuela</strong> (INBI/FAST)
                    y <strong>curso</strong> para que el agente envíe el archivo correcto.
                  </div>
                  <v-spacer></v-spacer>
                  <v-select
                    v-model="filtroTipo"
                    :items="opcionesTipo"
                    label="Tipo"
                    dense
                    outlined
                    hide-details
                    clearable
                    style="max-width: 200px"
                    class="mr-2 mb-1"
                    @change="cargarRecursos"
                  ></v-select>
                  <v-select
                    v-model="filtroEscuela"
                    :items="opcionesEscuela"
                    label="Escuela"
                    dense
                    outlined
                    hide-details
                    clearable
                    style="max-width: 140px"
                    class="mr-2 mb-1"
                    @change="cargarRecursos"
                  ></v-select>
                  <v-btn small color="primary" class="mb-1" @click="abrirNuevoRecurso">
                    <v-icon left small>mdi-plus</v-icon>
                    Nuevo / editar
                  </v-btn>
                </div>
                <v-data-table
                  :headers="headersRecursos"
                  :items="recursos"
                  dense
                  :loading="cargando"
                  class="elevation-0"
                >
                  <template v-slot:item.tipo_recurso="{ item }">
                    <span class="text-caption">{{ etiquetaTipo(item.tipo_recurso) }}</span>
                  </template>
                  <template v-slot:item.marca="{ item }">
                    <v-chip x-small outlined>{{ String(item.marca || '').toUpperCase() }}</v-chip>
                  </template>
                  <template v-slot:item.curso="{ item }">
                    <span class="text-caption">{{ etiquetaCurso(item.curso) }}</span>
                  </template>
                  <template v-slot:item.activo_sn="{ item }">
                    <v-chip x-small :color="item.activo_sn ? 'green' : 'grey'" dark>
                      {{ item.activo_sn ? 'activo' : 'inactivo' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.url_recurso="{ item }">
                    <a
                      v-if="item.url_recurso"
                      :href="item.url_recurso"
                      target="_blank"
                      class="text-caption"
                    >abrir</a>
                    <span v-else>—</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon small @click="abrirRecurso(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                    <v-btn
                      icon
                      small
                      color="orange"
                      title="Desactivar"
                      @click="desactivarRecurso(item)"
                    >
                      <v-icon small>mdi-pause-circle</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-tab-item>

              <!-- EVALUAR -->
              <v-tab-item>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="evalForm.id_programa"
                      label="id_programa"
                      dense
                      outlined
                      hint="curso_intensivo | curso_teens | …"
                      persistent-hint
                    ></v-text-field>
                    <v-checkbox
                      v-model="evalForm.quiere_inscribirse"
                      label="Quiere inscribirse / cómo pago"
                      dense
                      hide-details
                      class="mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="evalForm.inversion_confirmada"
                      label="Inversión vista/aceptada"
                      dense
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="evalForm.examen_recibido"
                      label="Examen / link recibido"
                      dense
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="evalForm.grupo_tentativo"
                      label="Grupo / horario tentativo"
                      dense
                      hide-details
                    ></v-checkbox>
                    <v-btn
                      class="mt-3"
                      color="primary"
                      small
                      :loading="evaluando"
                      @click="evaluar"
                    >
                      Evaluar gates
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="6">
                    <pre class="eval-json text-caption">{{ evalResultJson }}</pre>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogRecurso" max-width="600">
      <v-card>
        <v-card-title>{{ recursoForm.id_recurso ? 'Editar recurso' : 'Recurso' }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="recursoForm.id_recurso"
            label="id_recurso"
            dense
            outlined
            :disabled="!!recursoEditando"
          ></v-text-field>
          <v-text-field
            v-model="recursoForm.nombre_publico"
            label="Nombre público"
            dense
            outlined
          ></v-text-field>
          <v-select
            v-model="recursoForm.tipo_recurso"
            :items="opcionesTipo"
            label="Tipo de recurso"
            dense
            outlined
            hint="Métodos de pago, PDF del método / inmersión o audio de propuesta"
            persistent-hint
            class="mb-2"
          ></v-select>
          <v-select
            v-model="recursoForm.marca"
            :items="opcionesEscuela"
            label="Escuela"
            dense
            outlined
          ></v-select>
          <v-select
            v-model="recursoForm.curso"
            :items="opcionesCurso"
            label="Curso"
            dense
            outlined
            clearable
            hint="Vacío = genérico para todos los cursos de esa escuela"
            persistent-hint
            class="mb-2"
          ></v-select>
          <v-file-input
            v-model="recursoArchivo"
            label="Archivo PDF, imagen o audio"
            dense
            outlined
            show-size
            truncate-length="28"
            accept=".pdf,.jpg,.jpeg,.png,.webp,.gif,.ogg,.oga,.opus,.mp3,.m4a,.aac,image/*,audio/*,audio/ogg,audio/mpeg,audio/mp4,audio/x-m4a,audio/aac,audio/opus,application/ogg,application/pdf"
            prepend-icon="mdi-paperclip"
            hint="PDF/imagen o audio ogg/mp3/m4a. Obligatorio al crear o para reemplazar."
            persistent-hint
            class="mb-2"
          ></v-file-input>
          <div v-if="recursoForm.url_recurso" class="mb-3 text-caption">
            Archivo actual:
            <a :href="recursoForm.url_recurso" target="_blank" rel="noopener">abrir / descargar</a>
          </div>
          <v-select
            v-model="recursoForm.tipo_archivo"
            :items="['pdf', 'imagen', 'audio']"
            label="Formato archivo"
            dense
            outlined
            hint="Se ajusta solo al subir el archivo"
            persistent-hint
          ></v-select>
          <v-text-field
            v-model="recursoForm.region"
            label="Región (opcional)"
            dense
            outlined
            clearable
          ></v-text-field>
          <v-switch
            v-model="recursoForm.activo_sn"
            label="Activo"
            :true-value="1"
            :false-value="0"
          ></v-switch>
          <v-textarea
            v-model="recursoForm.notas"
            label="Notas"
            dense
            outlined
            rows="2"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogRecurso = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="guardarRecurso">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const CURSOS_DEFAULT = [
  { value: '', text: 'Todos / genérico' },
  { value: 'curso_intensivo_presencial_adultos', text: 'Intensivo presencial (adultos)' },
  { value: 'curso_intensivo_en_linea_adultos', text: 'Intensivo en línea (adultos)' },
  { value: 'curso_teens_presencial', text: 'Teens presencial' },
]

const TIPOS_DEFAULT = [
  { value: 'metodos_pago', text: 'Métodos de pago' },
  { value: 'metodo_inmersion', text: 'Método / inmersión' },
  { value: 'audio_propuesta', text: 'Audio de propuesta' },
]

const ESCUELAS_DEFAULT = [
  { value: 'inbi', text: 'INBI' },
  { value: 'fast', text: 'FAST' },
]

export default {
  name: 'PagosGatesAdmin',

  data: () => ({
    tab: 0,
    cargando: false,
    guardando: false,
    evaluando: false,
    status: null,
    error: null,
    gates: [],
    recursos: [],
    filtroTipo: null,
    filtroEscuela: null,
    catalogo: {
      tipos_recurso: TIPOS_DEFAULT,
      escuelas: ESCUELAS_DEFAULT,
      cursos: CURSOS_DEFAULT,
    },
    dialogRecurso: false,
    recursoEditando: false,
    recursoArchivo: null,
    recursoForm: {
      id_recurso: '',
      nombre_publico: '',
      url_recurso: '',
      tipo_archivo: 'pdf',
      tipo_recurso: 'metodos_pago',
      marca: 'inbi',
      curso: '',
      region: null,
      activo_sn: 0,
      notas: '',
    },
    evalForm: {
      id_programa: 'curso_intensivo',
      quiere_inscribirse: true,
      inversion_confirmada: false,
      examen_recibido: false,
      grupo_tentativo: false,
    },
    evalResult: null,
    headersGates: [
      { text: 'Gate', value: 'id_gate', width: 180 },
      { text: 'Pregunta', value: 'etiqueta' },
      { text: 'Requerido', value: 'requerido_sn', width: 100 },
      { text: 'Activo', value: 'activo_sn', width: 90 },
      { text: 'Orden', value: 'orden', width: 90 },
    ],
    headersRecursos: [
      { text: 'ID', value: 'id_recurso' },
      { text: 'Nombre', value: 'nombre_publico' },
      { text: 'Tipo', value: 'tipo_recurso', width: 130 },
      { text: 'Escuela', value: 'marca', width: 90 },
      { text: 'Curso', value: 'curso', width: 160 },
      { text: 'Estado', value: 'activo_sn', width: 90 },
      { text: 'Archivo', value: 'url_recurso', width: 90 },
      { text: '', value: 'actions', sortable: false, width: 90 },
    ],
  }),

  computed: {
    evalResultJson() {
      return this.evalResult ? JSON.stringify(this.evalResult, null, 2) : '// resultados aquí'
    },
    opcionesTipo() {
      return (this.catalogo && this.catalogo.tipos_recurso) || TIPOS_DEFAULT
    },
    opcionesEscuela() {
      return (this.catalogo && this.catalogo.escuelas) || ESCUELAS_DEFAULT
    },
    opcionesCurso() {
      return (this.catalogo && this.catalogo.cursos) || CURSOS_DEFAULT
    },
  },

  mounted() {
    this.cargarTodo()
  },

  methods: {
    etiquetaTipo(v) {
      const hit = this.opcionesTipo.find((o) => o.value === v)
      return (hit && hit.text) || v || '—'
    },
    etiquetaCurso(v) {
      if (!v) return 'Todos / genérico'
      const hit = this.opcionesCurso.find((o) => o.value === v)
      return (hit && hit.text) || v
    },

    async cargarRecursos() {
      const params = {}
      if (this.filtroTipo) params.tipo_recurso = this.filtroTipo
      if (this.filtroEscuela) params.marca = this.filtroEscuela
      const r = await this.$http.get('vendedor-ia.pagos.recursos', { params })
      this.recursos = (r.data && r.data.recursos) || []
      if (r.data && r.data.catalogo) this.catalogo = r.data.catalogo
    },

    async cargarTodo() {
      this.cargando = true
      this.error = null
      try {
        const [st, g] = await Promise.all([
          this.$http.get('vendedor-ia.pagos.status'),
          this.$http.get('vendedor-ia.pagos.gates'),
        ])
        this.status = st.data
        this.gates = (g.data && g.data.gates) || []
        await this.cargarRecursos()
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message)
          || e.message
          || 'Error al cargar'
      } finally {
        this.cargando = false
      }
    },

    async guardarGate(item) {
      try {
        await this.$http.put(`vendedor-ia.pagos.gates/${item.id_gate}`, {
          etiqueta: item.etiqueta,
          descripcion: item.descripcion,
          requerido_sn: item.requerido_sn ? 1 : 0,
          activo_sn: item.activo_sn ? 1 : 0,
          orden: Number(item.orden) || 100,
        })
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message) || e.message
        this.cargarTodo()
      }
    },

    abrirNuevoRecurso() {
      this.recursoEditando = false
      this.recursoArchivo = null
      const tipo = this.filtroTipo || 'metodos_pago'
      const escuela = this.filtroEscuela || 'inbi'
      const esAudio = tipo === 'audio_propuesta'
      const esMetodo = tipo === 'metodo_inmersion'
      this.recursoForm = {
        id_recurso: esAudio
          ? `${escuela}_audio_propuesta_presencial`
          : esMetodo
            ? `${escuela}_metodo_intensivo_presencial`
            : `${escuela}_metodos_pago_nacional`,
        nombre_publico: esAudio
          ? `Audio propuesta ${escuela.toUpperCase()}`
          : esMetodo
            ? `Método inmersión ${escuela.toUpperCase()}`
            : `Métodos de pago ${escuela.toUpperCase()}`,
        url_recurso: '',
        tipo_archivo: esAudio ? 'audio' : 'pdf',
        tipo_recurso: tipo,
        marca: escuela,
        curso: (esAudio || esMetodo) ? 'curso_intensivo_presencial_adultos' : '',
        region: null,
        activo_sn: 1,
        notas: '',
      }
      this.dialogRecurso = true
    },

    abrirRecurso(item) {
      this.recursoEditando = true
      this.recursoArchivo = null
      this.recursoForm = {
        id_recurso: item.id_recurso,
        nombre_publico: item.nombre_publico,
        url_recurso: item.url_recurso,
        tipo_archivo: item.tipo_archivo || 'pdf',
        tipo_recurso: item.tipo_recurso || 'metodos_pago',
        marca: item.marca || 'inbi',
        curso: item.curso || '',
        region: item.region,
        activo_sn: item.activo_sn ? 1 : 0,
        notas: item.notas || '',
      }
      this.dialogRecurso = true
    },

    async guardarRecurso() {
      const id = String(this.recursoForm.id_recurso || '').trim()
      if (!id) {
        this.error = 'id_recurso requerido'
        return
      }
      const urlActual = String(this.recursoForm.url_recurso || '')
      const archivoInterno = /\/formas-de-pago\/via-metodos-pago\//.test(urlActual)
      if (!this.recursoArchivo && (!urlActual || !archivoInterno)) {
        this.error = 'Sube el PDF, imagen u audio oficial (ya no se acepta pegar un link)'
        return
      }
      this.guardando = true
      this.error = null
      try {
        if (this.recursoArchivo) {
          const fd = new FormData()
          fd.append('file', this.recursoArchivo)
          fd.append('nombre_publico', this.recursoForm.nombre_publico || id)
          fd.append('marca', this.recursoForm.marca || 'inbi')
          fd.append('tipo_recurso', this.recursoForm.tipo_recurso || 'metodos_pago')
          fd.append('curso', this.recursoForm.curso || '')
          fd.append('region', this.recursoForm.region || '')
          fd.append('activo_sn', this.recursoForm.activo_sn ? '1' : '0')
          fd.append('notas', this.recursoForm.notas || '')
          fd.append('tipo_archivo', this.recursoForm.tipo_archivo || 'pdf')
          await this.$http.post(
            `vendedor-ia.pagos.recursos/${encodeURIComponent(id)}/archivo`,
            fd,
          )
        } else {
          const { url_recurso, ...meta } = this.recursoForm
          await this.$http.put(`vendedor-ia.pagos.recursos/${encodeURIComponent(id)}`, {
            ...meta,
            curso: meta.curso || null,
            url_recurso,
          })
        }
        this.dialogRecurso = false
        this.recursoArchivo = null
        await this.cargarTodo()
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message) || e.message
      } finally {
        this.guardando = false
      }
    },

    async desactivarRecurso(item) {
      try {
        await this.$http.post(`vendedor-ia.pagos.recursos/${item.id_recurso}/desactivar`)
        await this.cargarTodo()
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message) || e.message
      }
    },

    async evaluar() {
      this.evaluando = true
      try {
        const res = await this.$http.post('vendedor-ia.pagos.gates.evaluar', {
          marca: 'inbi',
          ...this.evalForm,
        })
        this.evalResult = res.data
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message) || e.message
      } finally {
        this.evaluando = false
      }
    },
  },
}
</script>

<style scoped>
.eval-json {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 12px;
  max-height: 360px;
  overflow: auto;
}
</style>
